import type { User } from 'types'

const blankUser = {} as User
const isParent = ({ role }: User = blankUser) =>
  (role ?? '').toLowerCase().includes('parent')

export default isParent
